import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { RRule } from 'rrule';
import { DateUtilities } from '../../shared/utilities/dateUtilities';
import { RRULETRANSLATE } from './danishRecurrance';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { CompanyInformation, CompanyLanguage, SubscriptionObject } from 'app/shared/models/standard.models';
import { DateUtilities as Datepick } from 'app/shared/utilities/dateUtilities';

@Component({
  selector: 'app-recurrance-calculator',
  templateUrl: './recurrance-calculator.component.html',
  styleUrls: ['./recurrance-calculator.component.css']
})
export class RecurranceCalculatorComponent implements OnInit, OnChanges, OnDestroy {

  @Input() date: string;
  @Input() rule: string;
  @Input('options') optionsInput; 
  @Output() recurrances = new EventEmitter<Array<string>>();
  @Output() infinityRecurring = new EventEmitter<number>();
  @Output() ruleChange = new EventEmitter<string>();
  @Output() change = new EventEmitter();
  subs: SubscriptionObject = new SubscriptionObject();
  options = {
    hideResult: false,
    areaBg: 'none',
    autoOpen: false
  };
  bsConfig = Datepick.bsConfig;

  rrule: RRule;
  rruleResults: Array<Date>;
  rruleText:string = '';
  settings = new RecurringSettings();
  dateUtils = new DateUtilities();
  weekDaysSelected = new WeekdaySelector();

  // ----------- LEGACY variables
  useRecurring = false;
  useInfinityRecurring = false;
  recurranceFrequency: 'reccurance' | 'week' | 'month' = 'reccurance';
  monthlyRecurranceType: 'date' | 'dayInWeek' = 'date';
  monthlyRecurranceOffset: 'first' | 'second' | 'third' | 'fourth' | 'last' = 'first';
  monthlyReccuranceWeekday: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday' = 'monday';
  monthlyDay: number;
  everyNthWeek: number = 1;
  everyNthMonth: number = 1;
  dateInMonth: number = new Date().getDate() + 1;
  recurranceEndType: 'endDate' | 'afterNth' = 'afterNth';
  lastAddedDate: Date;
  startDate: Date;
  endAfterNth: number = 3;
  infinityRecurringDays: number = 7;
  endDate;
  maxEndDate;
  recurranceArray = [];
  startTime: string;
  duration: number;
  stop = false;
  test: boolean = false; // to double check the next date
  nextDate: Date;
  language!:string;

  constructor(private shared: SharedDataService) { }

  ngOnInit() {
    if (this.options.autoOpen) this.newRule();
    this.subs['compInfo'] = this.shared.companyInformation().subscribe((data: CompanyInformation) => {if(data) this.language = data.companyLanguage})
  }

  ngOnChanges(change: SimpleChanges) {
    if (!!change && !!change.date && change.date.currentValue != change.date.previousValue) {
      if (this.date != null && !!this.rrule && this.rrule.options) {
        this.rrule.options.dtstart = new Date(this.date);
        this.rrule.origOptions.dtstart = new Date(this.date);
        this.updateResults();
      }
    }
    if (!!change && !!change.rule && !!change.rule.currentValue && change.rule.currentValue != change.rule.previousValue && !!this.date) {
      let a = RRule.fromString(change.rule.currentValue);
      a.options.dtstart = new Date(this.date);
      a.origOptions.dtstart = new Date(this.date);
      // Need to set settings.offset based on the rules freq less than 2 (0=yearly, 1=monthly etc.).
      if(a.origOptions.freq < 2 && a.origOptions.byweekday) {
        this.settings.offset = !!a.origOptions.byweekday[0].n ? a.origOptions.byweekday[0].n : 0;
      };
      if(a.options.interval == 1 && !!a.options.bymonthday && a.options.bymonthday[0] != a.options.dtstart.getDate()){ a.options.bymonthday = [a.options.dtstart.getDate()];
      }
      this.startUpCheck(a.options);
      if (a.options.count) { this.settings.count = a.options.count; this.settings.end = 'quantity' }
      else if (a.options.until) { this.settings.until = new Date(a.options.until); this.settings.end = 'date' }
      else { this.settings.end = 'none' }
      this.rrule = a;
      this.settings.freq = this.dateUtils.frequencyToString(a.options.freq);
      this.updateResults();
    }
    if(!!change.optionsInput && !!change.optionsInput.currentValue) {
      for (const [key, value] of Object.entries(this.optionsInput)) this.options[key] = value;
    }
  }

  ngOnDestroy(): void {
    for(let key of Object.keys(this.subs)) this.subs[key].unsubscribe();
  }


  startUpCheck(r: RRule['options']) {
    this.weekDaysSelected = new WeekdaySelector();
    const weekdayMap = Object.keys(this.weekDaysSelected);
    if (!!r.byweekday) {
      r.byweekday.forEach(x => { this.weekDaysSelected[weekdayMap[x]] = true; });
    }
    else if (r.bynweekday) {
      r.bynweekday.forEach(([weekday, _]) => { this.weekDaysSelected[weekdayMap[weekday]] = true; });
    }
    
  }

  newRule() {
    this.settings.freq = 'daily';
    this.rrule = RRule.fromString('RRULE:FREQ=DAILY;INTERVAL=1;WKST=MO');
    this.ruleChanged();
  }

  removeRule() {
    this.emitRule(null);
    this.rule = null; 
    //this.options.autoOpen = false;
  }

  frequencyChange() {
    /**
     * If frequency is set to:
     * yearly
     * monthly
     * weekly
     * daily
     */
    switch (this.settings.freq) {
      case ('yearly'): { this.rrule.options.interval = 1; this.settings.by = 'week'; break }
      case ('monthly'): { this.rrule.options.interval = 1; this.settings.by = 'week'; break }
      case ('weekly'): { this.rrule.options.interval = 1; this.settings.by = 'week'; break }
      case ('daily'): { this.rrule.options.interval = 1; break }
    }
    this.rrule.options.freq = RRule[this.settings.freq.toUpperCase()];
    this.ruleChanged();
  }

  addMonth(month: number) {
    if (!this.rrule.options.bymonth) { this.rrule.options.bymonth = [] }
    if (!this.rrule.options.bymonth.includes(month)) { this.rrule.options.bymonth.push(month) }
    else { this.rrule.options.bymonth = this.rrule.options.bymonth.filter(x => x != month) }
    this.ruleChanged()
  }

  byDayChange() {
    this.settings.daysSelected = Object.keys(this.weekDaysSelected).filter(x => !!this.weekDaysSelected[x]).map(x => RRule[x.toUpperCase()]);
    if (this.settings.daysSelected.length == 1) {
      let o = this.settings.offset; // should be number based on weekOffsetSelector.
      this.rrule.options.byweekday = o != null && o != undefined && this && o != 0 ? RRule[this.settings.daysSelected[0]].nth(o) : RRule[this.settings.daysSelected[0]].weekday;
    }
    else if (this.settings.daysSelected.length > 1) {
      this.rrule.options.byweekday = !!this.settings.offset && this.settings.offset != 0 ? this.settings.daysSelected.map(x => { return RRule[x].nth(this.settings.offset) }) : this.settings.daysSelected.map(x => x.weekday)
    }
    else { this.rrule.options.byweekday = null }
    this.ruleChanged();
  }

  async ruleChanged() {
    setTimeout(()=> { // timeout neeeded in order for the ngModel values to be switched.
      let opt = this.rrule.options;
      let a = {
        freq: opt.freq,
        interval: opt.interval,
        wkst: RRule.MO,
        count: !!opt.count ? opt.count : null
      };
    
      if (!!opt.until && !!opt.dtstart){
         a['until'] = opt.until;
        this.rrule.origOptions.until = opt.until
      }
      else delete a['until']; // Superfluous?
    
      if(opt.freq < 3 && opt.byweekday) a['byweekday'] = opt.byweekday;
    
      this.ruleBySwitch(a);
    
      let newRule = new RRule(a);
      newRule.options.dtstart = new Date(this.date);
    
      this.rrule = newRule;
      this.emitRule(newRule.toString());
    
      setTimeout(()=> this.updateResults(), 200);

    },200)
  }

  dateChanged(){
    this.rrule.options.dtstart = new Date(this.date);
  }

  ruleBySwitch(rule) {
    switch (this.settings.freq) {
      case ('yearly'): {
        rule['bymonth'] = this.rrule.options.bymonth;
        switch (this.settings.by) {
          case ('week'): { rule['byweekday'] = this.rrule.options.byweekday; break }
          case ('date'): { rule['bymonthday'] = this.rrule.options.bymonthday; break }
        }
      }
      case ('monthly'): {
        switch (this.settings.by) {
          case ('week'): { rule['byweekday'] = this.rrule.options.byweekday; this.rrule.options.bymonthday = null; break }
          case ('date'): { rule['bymonthday'] = this.rrule.options.bymonthday;this.rrule.options.byweekday = null; break }
        }
        ; break
      }
      case ('weekly'): { rule['byweekday'] = this.rrule.options.byweekday; break }
      case ('daily'): { break }
    }
  }

  updateResults() {
    let a = RRule.fromString(this.rrule.toString());
    this.translateRule();
    if (!!this.date) {
      a.options.dtstart = new Date(this.date);
      if(a.options.freq == 3) {
        a.options.bymonthday = null; 
        a.origOptions.byweekday = null;
        a.options.byweekday = null;
      };
    };
    if (this.settings.end == 'none') { a.options.count = 10; }
    else if (this.settings.count) { a.options.count = this.settings.count + 1; }
    this.rruleResults = a.all().filter(x => !this.dateUtils.isSameDate(x, new Date(this.date)));
    if(!!this.test) this.createNewDate();
  }

  emitRule(rule: string) { 
    this.ruleChange.emit(rule); 
    this.change.emit(rule);
  }

  translateRule(){
    this.rruleText = RRULETRANSLATE.rruleTranslation(this.rrule.toText(), this.language as CompanyLanguage );
  }

  numInByMonth(num: number) {
    if (!this.rrule.options.bymonth) { return false }
    if (this.rrule.options.bymonth.includes(num)) { return true }
    return false
  }

  setEndDate() {
    let r = this.rrule.options;
    if (!!r.dtstart && new Date(r.dtstart).toString() != 'Invalid Date') {
      switch (this.settings.freq) {
        case ('yearly'): {
          r.until = new Date(r.dtstart.getFullYear() + (r.interval * 10), r.dtstart.getMonth(), r.dtstart.getDate());
          break
        }
        case ('monthly'):
        case ('weekly'): {
          r.until = new Date(r.dtstart.getFullYear(), r.dtstart.getMonth() + (r.interval * 5), r.dtstart.getDate());
          break
        }
        case ('daily'): {
          r.until = new Date(r.dtstart.getFullYear(), r.dtstart.getMonth(), r.dtstart.getDate() + (r.interval * 10));
          break
        }
      }
      this.ruleChanged();
    } else {
      let a = new Date();
      a.setFullYear(a.getFullYear() + 1);
      r.until = a;
      this.ruleChanged();
    }
  }

  //  --------- LEGACY

  updateArray() {
    let stop = false;
    this.recurranceArray = [];
    this.lastAddedDate = this.startDate;
    while (stop == false) {
      switch (this.recurranceFrequency) {
        case ('reccurance'): {
          this.useInfinityRecurring = true;
          stop = true;
          ; break;
        }
        case ('week'): {
          let date = this.lastAddedDate;
          // get index of first day to check if any of the active days
          let activeDays = this.findActiveDaysAndOffsets();
          if (activeDays.length == 0) { stop = true }
          while (stop == false) {
            for (let x of activeDays) {
              let newDate = new Date(this.lastAddedDate.getFullYear(), this.lastAddedDate.getMonth(), this.lastAddedDate.getDate() + x.daysToNext);
              if (this.checkIfLast(newDate) == false) {
                this.recurranceArray.push(newDate.toLocaleString());
                this.lastAddedDate = newDate;
              }
              else { stop = true }
            } // end of for loop
          } // end of while
          stop = true;
          ; break;
        }
        case ('month'): {
          switch (this.monthlyRecurranceType) {
            case ('date'): {
              let newDate = new Date(this.lastAddedDate.getFullYear(), this.lastAddedDate.getMonth() + this.everyNthMonth, this.dateInMonth);
              if (this.checkIfLast(newDate) == false) {
                this.recurranceArray.push(newDate.toLocaleString());
                this.lastAddedDate = newDate;
              }
              else { stop = true }
              ; break;
            }
            case ('dayInWeek'): {
              if (this.monthlyRecurranceOffset == 'last') {
                let newMonth = new Date(this.lastAddedDate.getFullYear(), this.lastAddedDate.getMonth() + this.everyNthMonth + 1, 1);
                let daysAddedFromFirst = this.getWeekIndexDifference(this.convertDateDayToWeekIndex(newMonth), this.convertDayStringToIndex(this.monthlyReccuranceWeekday), false);
                let newDate = new Date(newMonth.getFullYear(), newMonth.getMonth(), 1 + daysAddedFromFirst);
                if (this.checkIfLast(newDate) == false) {
                  this.recurranceArray.push(newDate.toLocaleString());
                  this.lastAddedDate = newDate;
                }
                else { stop = true }
              }
              else {
                let weekNumber = ['first', 'second', 'third', 'fourth', 'last'].indexOf(this.monthlyRecurranceOffset);
                let newMonth = new Date(this.lastAddedDate.getFullYear(), this.lastAddedDate.getMonth() + this.everyNthMonth, 1);
                let daysAddedFromFirst = this.getWeekIndexDifference(this.convertDateDayToWeekIndex(newMonth), this.convertDayStringToIndex(this.monthlyReccuranceWeekday), true);
                let newDate = new Date(newMonth.getFullYear(), newMonth.getMonth(), 1 + daysAddedFromFirst + (weekNumber * 7));
                if (this.checkIfLast(newDate) == false) {
                  this.recurranceArray.push(newDate.toLocaleString());
                  this.lastAddedDate = newDate;
                }
                else { stop = true }
              }
              ; break;
            }
          }
          ; break
        }
      } // end of Switch
    }
    if (this.useRecurring) { this.recurrances.emit(this.recurranceArray); }
    if (this.useInfinityRecurring) { this.infinityRecurring.emit(this.infinityRecurringDays); }
  }

  checkIfLast(date: Date) {
    let a = this.maxEndDate;
    let end = new Date(a.year, a.month, a.day)
    switch (this.recurranceEndType) {
      case ('endDate'): {
        let b = this.endDate != null ? new Date(this.endDate.singleDate.date.year, this.endDate.singleDate.date.month, this.endDate.singleDate.date.day) : end;
        return date > b ? true : false;
      }
      case ('afterNth'): {
        if (this.recurranceArray.length > this.endAfterNth - 1 || date > end) {
          return true
        }
        return false
      }
    }

  }

  findActiveDaysAndOffsets() {
    let days = [];
    let start = Object.keys(this.weekDaysSelected);
    for (let x of start) {
      if (this.weekDaysSelected[x]) {
        days.push({ index: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].indexOf(x), day: x })
      }
    }
    if (days.length == 1) { days[0]['daysToNext'] = 7 + ((this.everyNthWeek - 1) * 7) }
    else {
      for (var i = 0; i < days.length; i++) {
        let current = days[i];
        let sibling = days[i + 1];
        if (i != days.length - 1) {
          days[i]['daysToNext'] = (sibling.index - current.index)
        }
        else {
          days[i]['daysToNext'] = (7 - current.index + days[0].index + ((this.everyNthWeek - 1) * 7))
        }
      }
    }
    return days
  }

  convertDateDayToWeekIndex(date: Date) {
    return [1, 2, 3, 4, 5, 6, 0].indexOf(date.getDay());
  }

  convertDayStringToIndex(day: string) {
    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].indexOf(day)
  }

  convertWeekIndexToWeekDayString(i: number) {
    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'][i]
  }

  getWeekIndexDifference(today: number, next: number, forward: boolean) {
    if (today == next) {
      return 0
    }
    if (forward == true) {
      return today < next ? next - today : 7 - today + next;
    }
    else {
      return today < next ? next - 7 - today : - today + next;
    }
  }

  updateStartDate(date: string) {
    let originDate = new Date(date);
    this.maxEndDate = {
      year: originDate.getFullYear(),
      month: originDate.getMonth() + 6,
      day: originDate.getDate()
    };
    this.endDate = {
      isRange: false,
      singleDate: {
        date: {
          year: originDate.getFullYear(),
          month: originDate.getMonth() + 1,
          day: originDate.getDate()
        }
      }
    };
    this.startDate = new Date(date);
    this.dateInMonth = originDate.getDate();
    let days: Array<'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'> = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    this.monthlyReccuranceWeekday = days[originDate.getDay()];
    this.weekDaysSelected = new WeekdaySelector();
    this.weekDaysSelected[this.monthlyReccuranceWeekday] = true;
    this.monthlyRecurranceOffset = this.getOffset(originDate);
    this.updateArray();
  }

  getOffset(date: Date): 'first' | 'second' | 'third' | 'fourth' | 'last' {
    let year = date.getFullYear();
    let month = date.getMonth();
    let firstWeekdayOfMonth = new Date(year, month, 1).getDay() - 1;
    if (firstWeekdayOfMonth < 0) firstWeekdayOfMonth = 6;
    var offsetDate = date.getDate() + firstWeekdayOfMonth - 1
    let result = Math.floor(offsetDate / 7)
    if (result == 0) { return 'first' }
    if (result == 1) { return 'second' }
    if (result == 2) { return 'third' }
    if (result == 3) { return 'fourth' }
    else { return 'last' }
  }

  removeRecurrances() {
    this.recurranceArray = [];
    this.recurrances.emit(null)
  }

  async createNewDate(){
    this.nextDate = await this.dateUtils.getNextDateInRule(this.rrule.toString(), new Date(this.date))
  }

}

export class RecurringSettings {
  freq: string;
  count: number;
  daysSelected: Array<any>;
  offset: number = 0; // offset needs to be set if freq < 3 (0: Yearly, 1: Monthly). It equals week selector, 1st in month etc. ranges from -2 to +2, 0 is every week.
  show = false;
  by: 'week' | 'date' = 'week';
  until: Date;
  end: 'none' | 'quantity' | 'date' = 'none';
}

export class WeekdaySelector {
  mo = false;
  tu = false;
  we = false;
  th = false;
  fr = false;
  sa = false;
  su = false;
}
